import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../../../theme';
import { DigestFrequency } from '../types/onboarding';

interface DaysVisualizationProps {
  frequency: DigestFrequency | null;
}

export const DaysVisualization: React.FC<DaysVisualizationProps> = ({ frequency }) => {

  const getDayActive = (index: number): boolean => {
    if (!frequency) return false;
    if (frequency === 1) return index === 0; // Monday only
    if (frequency === 3) return index === 0 || index === 2 || index === 4; // M, W, F
    if (frequency === 5) return index <= 4; // M-F
    if (frequency === 7) return true; // All days
    return false;
  };

  return (
    <Box sx={{ display: 'flex', gap: '8px', width: '100%' }}>
      {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((day, index) => {
        const isActive = getDayActive(index);
        return (
          <Box
            key={`${day}-${index}`}
            sx={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.875rem',
              fontWeight: 600,
              backgroundColor: isActive ? colors.slate[600] : colors.slate[100],
              color: isActive ? colors.pureWhite : colors.slate[400],
              transition: 'all 0.2s ease',
            }}
          >
            {day}
          </Box>
        );
      })}
    </Box>
  );
};
